import { render, staticRenderFns } from "./ruletoorderwt.vue?vue&type=template&id=c44fc45a"
import script from "./ruletoorderwt.vue?vue&type=script&lang=js"
export * from "./ruletoorderwt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports